/**
 * Shared language + public URL helpers for arcade games.
 * Language order: ?lang=tr|en → launcher/hub preference (`enjoyment.lang`) → browser language.
 */
export type Lang = "tr" | "en";

export function currentLang(): Lang {
  try {
    const requested = new URLSearchParams(location.search).get("lang");
    if (requested === "tr" || requested === "en") return requested;
  } catch {
    /* no location (tests) */
  }
  try {
    const saved = localStorage.getItem("enjoyment.lang");
    if (saved === "tr" || saved === "en") return saved;
  } catch {
    /* storage unavailable */
  }
  try {
    return (navigator.language || "tr").toLowerCase().startsWith("tr") ? "tr" : "en";
  } catch {
    return "tr";
  }
}

/** Pick the string for the active language. */
export function pick<T>(lang: Lang, value: { tr: T; en: T }): T {
  return value[lang];
}

/** Canonical public domain shared by the arcade game's subdomains. */
export const GAME_DOMAIN = "enjoyment.app";

export function publicGameUrl(id: string): string {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(id)) {
    throw new Error(`Invalid game subdomain: ${id}`);
  }
  return `https://${id}.${GAME_DOMAIN}/`;
}
